import posthog from 'posthog-js';
import type { PersonProperties } from './types';

/**
 * person property を `$set` する薄いラッパー。
 *
 * init 前（テスト / 未構築環境・GF-1897）は送らない（trackEvent と同型のガード）。
 * identify 後に変動する属性（linkedProviders 等）を、identify を待たずその場で更新するために使う。
 */
export const setPersonProperties = (props: Partial<PersonProperties>): void => {
  if (!posthog.__loaded) return;
  posthog.setPersonProperties(props);
};
